__turbopack_context__.v({
  "className": "gothambook_d748f219-module__ag9ecG__className",
});
